"use strict";

var _regeneratorRuntime = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/createClass");

var _asyncToGenerator = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReverseTwitterRegistry = exports.ReverseTwitterRegistryState = exports.getTwitterRegistryData = exports.getTwitterHandleandRegistryKeyViaFilters = exports.getHandleAndRegistryKey = exports.getTwitterRegistry = exports.getTwitterRegistryKey = exports.deleteTwitterRegistry = exports.changeVerifiedPubkey = exports.changeTwitterRegistryData = exports.createVerifiedTwitterRegistry = exports.TWITTER_ROOT_PARENT_REGISTRY_KEY = exports.TWITTER_VERIFICATION_AUTHORITY = void 0;

var web3_js_1 = require("@solana/web3.js");

var bindings_1 = require("./bindings");

var instructions_1 = require("./instructions");

var state_1 = require("./state");

var utils_1 = require("./utils");

var borsh_1 = require("borsh"); ////////////////////////////////////////////////////
// Global Variables


exports.TWITTER_VERIFICATION_AUTHORITY = new web3_js_1.PublicKey('FvPH7PrVrLGKPfqaf3xJodFTjZriqrAXXLTVWEorTFBi'); // The address of the name registry that will be a parent to all twitter handle registries,
// it should be owned by the TWITTER_VERIFICATION_AUTHORITY and it's name is irrelevant

exports.TWITTER_ROOT_PARENT_REGISTRY_KEY = new web3_js_1.PublicKey('4YcexoW3r78zz16J2aqmukBLRwGq6rAvWzJpkYAXqebv'); ////////////////////////////////////////////////////
// Bindings
// Signed by the authority, the payer and the verified pubkey

function createVerifiedTwitterRegistry(_x, _x2, _x3, _x4, _x5) {
  return _createVerifiedTwitterRegistry.apply(this, arguments);
}

function _createVerifiedTwitterRegistry() {
  _createVerifiedTwitterRegistry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(connection, twitterHandle, verifiedPubkey, space, // The space that the user will have to write data into the verified registry
  payerKey) {
    var hashedTwitterHandle, twitterHandleRegistryKey, instructions;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return utils_1.getHashedName(twitterHandle);

          case 2:
            hashedTwitterHandle = _context2.sent;
            _context2.next = 5;
            return utils_1.getNameAccountKey(hashedTwitterHandle, undefined, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            twitterHandleRegistryKey = _context2.sent;
            _context2.t0 = instructions_1;
            _context2.t1 = bindings_1.NAME_PROGRAM_ID;
            _context2.t2 = web3_js_1.SystemProgram.programId;
            _context2.t3 = twitterHandleRegistryKey;
            _context2.t4 = verifiedPubkey;
            _context2.t5 = payerKey;
            _context2.t6 = hashedTwitterHandle;
            _context2.t7 = utils_1.Numberu64;
            _context2.next = 16;
            return connection.getMinimumBalanceForRentExemption(space);

          case 16:
            _context2.t8 = _context2.sent;
            _context2.t9 = new _context2.t7(_context2.t8);
            _context2.t10 = new utils_1.Numberu32(space);
            _context2.t11 = undefined;
            _context2.t12 = exports.TWITTER_ROOT_PARENT_REGISTRY_KEY;
            _context2.t13 = exports.TWITTER_VERIFICATION_AUTHORITY // Twitter authority acts as owner of the parent for all user-facing registries
            ;
            _context2.t14 = _context2.t0.createInstruction.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3, _context2.t4, _context2.t5, _context2.t6, _context2.t9, _context2.t10, _context2.t11, _context2.t12, _context2.t13);
            instructions = [_context2.t14];
            _context2.t15 = instructions;
            _context2.next = 27;
            return createReverseTwitterRegistry(connection, twitterHandle, twitterHandleRegistryKey, verifiedPubkey, payerKey);

          case 27:
            _context2.t16 = _context2.sent;
            instructions = _context2.t15.concat.call(_context2.t15, _context2.t16);
            return _context2.abrupt("return", instructions);

          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createVerifiedTwitterRegistry.apply(this, arguments);
}

exports.createVerifiedTwitterRegistry = createVerifiedTwitterRegistry; // Overwrite the data that is written in the user facing registry
// Signed by the verified pubkey

function changeTwitterRegistryData(_x6, _x7, _x8, _x9) {
  return _changeTwitterRegistryData.apply(this, arguments);
}

function _changeTwitterRegistryData() {
  _changeTwitterRegistryData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(twitterHandle, verifiedPubkey, offset, // The offset at which to write the input data into the NameRegistryData
  input_data) {
    var hashedTwitterHandle, twitterHandleRegistryKey, instructions;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return utils_1.getHashedName(twitterHandle);

          case 2:
            hashedTwitterHandle = _context3.sent;
            _context3.next = 5;
            return utils_1.getNameAccountKey(hashedTwitterHandle, undefined, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            twitterHandleRegistryKey = _context3.sent;
            instructions = [instructions_1.updateInstruction(bindings_1.NAME_PROGRAM_ID, twitterHandleRegistryKey, new utils_1.Numberu32(offset), input_data, verifiedPubkey)];
            return _context3.abrupt("return", instructions);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _changeTwitterRegistryData.apply(this, arguments);
}

exports.changeTwitterRegistryData = changeTwitterRegistryData; // Change the verified pubkey for a given twitter handle
// Signed by the Authority, the verified pubkey and the payer

function changeVerifiedPubkey(_x10, _x11, _x12, _x13, _x14) {
  return _changeVerifiedPubkey.apply(this, arguments);
}

function _changeVerifiedPubkey() {
  _changeVerifiedPubkey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(connection, twitterHandle, currentVerifiedPubkey, newVerifiedPubkey, payerKey) {
    var hashedTwitterHandle, twitterHandleRegistryKey, instructions, currentHashedVerifiedPubkey, currentReverseRegistryKey;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return utils_1.getHashedName(twitterHandle);

          case 2:
            hashedTwitterHandle = _context4.sent;
            _context4.next = 5;
            return utils_1.getNameAccountKey(hashedTwitterHandle, undefined, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            twitterHandleRegistryKey = _context4.sent;
            // Transfer the user-facing registry ownership
            instructions = [instructions_1.transferInstruction(bindings_1.NAME_PROGRAM_ID, twitterHandleRegistryKey, newVerifiedPubkey, currentVerifiedPubkey, undefined)]; // Delete the current reverse registry

            _context4.next = 9;
            return utils_1.getHashedName(currentVerifiedPubkey.toString());

          case 9:
            currentHashedVerifiedPubkey = _context4.sent;
            _context4.next = 12;
            return utils_1.getNameAccountKey(currentHashedVerifiedPubkey, exports.TWITTER_VERIFICATION_AUTHORITY, undefined);

          case 12:
            currentReverseRegistryKey = _context4.sent;
            _context4.t0 = instructions;
            _context4.next = 16;
            return bindings_1.deleteNameRegistry(connection, currentVerifiedPubkey.toString(), payerKey, exports.TWITTER_VERIFICATION_AUTHORITY, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 16:
            _context4.t1 = _context4.sent;

            _context4.t0.push.call(_context4.t0, _context4.t1);

            _context4.t2 = instructions;
            _context4.next = 21;
            return createReverseTwitterRegistry(connection, twitterHandle, twitterHandleRegistryKey, newVerifiedPubkey, payerKey);

          case 21:
            _context4.t3 = _context4.sent;
            instructions = _context4.t2.concat.call(_context4.t2, _context4.t3);
            return _context4.abrupt("return", instructions);

          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _changeVerifiedPubkey.apply(this, arguments);
}

exports.changeVerifiedPubkey = changeVerifiedPubkey; // Delete the verified registry for a given twitter handle
// Signed by the verified pubkey

function deleteTwitterRegistry(_x15, _x16) {
  return _deleteTwitterRegistry.apply(this, arguments);
}

function _deleteTwitterRegistry() {
  _deleteTwitterRegistry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(twitterHandle, verifiedPubkey) {
    var hashedTwitterHandle, twitterHandleRegistryKey, hashedVerifiedPubkey, reverseRegistryKey, instructions;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return utils_1.getHashedName(twitterHandle);

          case 2:
            hashedTwitterHandle = _context5.sent;
            _context5.next = 5;
            return utils_1.getNameAccountKey(hashedTwitterHandle, undefined, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            twitterHandleRegistryKey = _context5.sent;
            _context5.next = 8;
            return utils_1.getHashedName(verifiedPubkey.toString());

          case 8:
            hashedVerifiedPubkey = _context5.sent;
            _context5.next = 11;
            return utils_1.getNameAccountKey(hashedVerifiedPubkey, exports.TWITTER_VERIFICATION_AUTHORITY, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 11:
            reverseRegistryKey = _context5.sent;
            instructions = [// Delete the user facing registry
            instructions_1.deleteInstruction(bindings_1.NAME_PROGRAM_ID, twitterHandleRegistryKey, verifiedPubkey, verifiedPubkey), // Delete the reverse registry
            instructions_1.deleteInstruction(bindings_1.NAME_PROGRAM_ID, reverseRegistryKey, verifiedPubkey, verifiedPubkey)];
            return _context5.abrupt("return", instructions);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteTwitterRegistry.apply(this, arguments);
}

exports.deleteTwitterRegistry = deleteTwitterRegistry; //////////////////////////////////////////
// Getter Functions
// Returns the key of the user-facing registry

function getTwitterRegistryKey(_x17) {
  return _getTwitterRegistryKey.apply(this, arguments);
}

function _getTwitterRegistryKey() {
  _getTwitterRegistryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(twitter_handle) {
    var hashedTwitterHandle;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return utils_1.getHashedName(twitter_handle);

          case 2:
            hashedTwitterHandle = _context6.sent;
            _context6.next = 5;
            return utils_1.getNameAccountKey(hashedTwitterHandle, undefined, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            return _context6.abrupt("return", _context6.sent);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getTwitterRegistryKey.apply(this, arguments);
}

exports.getTwitterRegistryKey = getTwitterRegistryKey;

function getTwitterRegistry(_x18, _x19) {
  return _getTwitterRegistry.apply(this, arguments);
}

function _getTwitterRegistry() {
  _getTwitterRegistry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(connection, twitter_handle) {
    var hashedTwitterHandle, twitterHandleRegistryKey, registry;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return utils_1.getHashedName(twitter_handle);

          case 2:
            hashedTwitterHandle = _context7.sent;
            _context7.next = 5;
            return utils_1.getNameAccountKey(hashedTwitterHandle, undefined, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            twitterHandleRegistryKey = _context7.sent;
            registry = state_1.NameRegistryState.retrieve(connection, twitterHandleRegistryKey);
            return _context7.abrupt("return", registry);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getTwitterRegistry.apply(this, arguments);
}

exports.getTwitterRegistry = getTwitterRegistry;

function getHandleAndRegistryKey(_x20, _x21) {
  return _getHandleAndRegistryKey.apply(this, arguments);
}

function _getHandleAndRegistryKey() {
  _getHandleAndRegistryKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(connection, verifiedPubkey) {
    var hashedVerifiedPubkey, reverseRegistryKey, reverseRegistryState;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return utils_1.getHashedName(verifiedPubkey.toString());

          case 2:
            hashedVerifiedPubkey = _context8.sent;
            _context8.next = 5;
            return utils_1.getNameAccountKey(hashedVerifiedPubkey, exports.TWITTER_VERIFICATION_AUTHORITY, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            reverseRegistryKey = _context8.sent;
            _context8.next = 8;
            return ReverseTwitterRegistryState.retrieve(connection, reverseRegistryKey);

          case 8:
            reverseRegistryState = _context8.sent;
            return _context8.abrupt("return", [reverseRegistryState.twitterHandle, new web3_js_1.PublicKey(reverseRegistryState.twitterRegistryKey)]);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getHandleAndRegistryKey.apply(this, arguments);
}

exports.getHandleAndRegistryKey = getHandleAndRegistryKey; // Uses the RPC node filtering feature, execution speed may vary

function getTwitterHandleandRegistryKeyViaFilters(_x22, _x23) {
  return _getTwitterHandleandRegistryKeyViaFilters.apply(this, arguments);
}

function _getTwitterHandleandRegistryKeyViaFilters() {
  _getTwitterHandleandRegistryKeyViaFilters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(connection, verifiedPubkey) {
    var filters, filteredAccounts, _iterator, _step, f, data, state;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            filters = [{
              memcmp: {
                offset: 0,
                bytes: exports.TWITTER_ROOT_PARENT_REGISTRY_KEY.toBase58()
              }
            }, {
              memcmp: {
                offset: 32,
                bytes: verifiedPubkey.toBase58()
              }
            }, {
              memcmp: {
                offset: 64,
                bytes: exports.TWITTER_VERIFICATION_AUTHORITY.toBase58()
              }
            }];
            _context9.next = 3;
            return utils_1.getFilteredProgramAccounts(connection, bindings_1.NAME_PROGRAM_ID, filters);

          case 3:
            filteredAccounts = _context9.sent;
            _iterator = _createForOfIteratorHelper(filteredAccounts);
            _context9.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context9.next = 15;
              break;
            }

            f = _step.value;

            if (!(f.accountInfo.data.length > state_1.NameRegistryState.HEADER_LEN + 32)) {
              _context9.next = 13;
              break;
            }

            data = f.accountInfo.data.slice(state_1.NameRegistryState.HEADER_LEN);
            state = borsh_1.deserialize(ReverseTwitterRegistryState.schema, ReverseTwitterRegistryState, data);
            return _context9.abrupt("return", [state.twitterHandle, new web3_js_1.PublicKey(state.twitterRegistryKey)]);

          case 13:
            _context9.next = 7;
            break;

          case 15:
            _context9.next = 20;
            break;

          case 17:
            _context9.prev = 17;
            _context9.t0 = _context9["catch"](5);

            _iterator.e(_context9.t0);

          case 20:
            _context9.prev = 20;

            _iterator.f();

            return _context9.finish(20);

          case 23:
            throw new Error('Registry not found.');

          case 24:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[5, 17, 20, 23]]);
  }));
  return _getTwitterHandleandRegistryKeyViaFilters.apply(this, arguments);
}

exports.getTwitterHandleandRegistryKeyViaFilters = getTwitterHandleandRegistryKeyViaFilters; // Uses the RPC node filtering feature, execution speed may vary
// Does not give you the handle, but is an alternative to getHandlesAndKeysFromVerifiedPubkey + getTwitterRegistry to get the data

function getTwitterRegistryData(_x24, _x25) {
  return _getTwitterRegistryData.apply(this, arguments);
}

function _getTwitterRegistryData() {
  _getTwitterRegistryData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(connection, verifiedPubkey) {
    var filters, filteredAccounts;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            filters = [{
              memcmp: {
                offset: 0,
                bytes: exports.TWITTER_ROOT_PARENT_REGISTRY_KEY.toBytes()
              }
            }, {
              memcmp: {
                offset: 32,
                bytes: verifiedPubkey.toBytes()
              }
            }, {
              memcmp: {
                offset: 64,
                bytes: new web3_js_1.PublicKey(Buffer.alloc(32, 0)).toBase58()
              }
            }];
            _context10.next = 3;
            return utils_1.getFilteredProgramAccounts(connection, bindings_1.NAME_PROGRAM_ID, filters);

          case 3:
            filteredAccounts = _context10.sent;

            if (!(filteredAccounts.length > 1)) {
              _context10.next = 6;
              break;
            }

            throw new Error('Found more than one registry.');

          case 6:
            return _context10.abrupt("return", filteredAccounts[0].accountInfo.data.slice(state_1.NameRegistryState.HEADER_LEN));

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _getTwitterRegistryData.apply(this, arguments);
}

exports.getTwitterRegistryData = getTwitterRegistryData; //////////////////////////////////////////////
// Utils

var ReverseTwitterRegistryState = /*#__PURE__*/function () {
  function ReverseTwitterRegistryState(obj) {
    _classCallCheck(this, ReverseTwitterRegistryState);

    this.twitterRegistryKey = obj.twitterRegistryKey;
    this.twitterHandle = obj.twitterHandle;
  }

  _createClass(ReverseTwitterRegistryState, null, [{
    key: "retrieve",
    value: function () {
      var _retrieve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection, reverseTwitterAccountKey) {
        var reverseTwitterAccount, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return connection.getAccountInfo(reverseTwitterAccountKey, 'processed');

              case 2:
                reverseTwitterAccount = _context.sent;

                if (reverseTwitterAccount) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Invalid reverse Twitter account provided');

              case 5:
                res = borsh_1.deserializeUnchecked(this.schema, ReverseTwitterRegistryState, reverseTwitterAccount.data.slice(state_1.NameRegistryState.HEADER_LEN));
                return _context.abrupt("return", res);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieve(_x26, _x27) {
        return _retrieve.apply(this, arguments);
      }

      return retrieve;
    }()
  }]);

  return ReverseTwitterRegistryState;
}();

exports.ReverseTwitterRegistryState = ReverseTwitterRegistryState;
ReverseTwitterRegistryState.schema = new Map([[ReverseTwitterRegistryState, {
  kind: 'struct',
  fields: [['twitterRegistryKey', [32]], ['twitterHandle', 'string']]
}]]);

function createReverseTwitterRegistry(_x28, _x29, _x30, _x31, _x32) {
  return _createReverseTwitterRegistry.apply(this, arguments);
}

function _createReverseTwitterRegistry() {
  _createReverseTwitterRegistry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(connection, twitterHandle, twitterRegistryKey, verifiedPubkey, payerKey) {
    var hashedVerifiedPubkey, reverseRegistryKey, reverseTwitterRegistryStateBuff;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return utils_1.getHashedName(verifiedPubkey.toString());

          case 2:
            hashedVerifiedPubkey = _context11.sent;
            _context11.next = 5;
            return utils_1.getNameAccountKey(hashedVerifiedPubkey, exports.TWITTER_VERIFICATION_AUTHORITY, exports.TWITTER_ROOT_PARENT_REGISTRY_KEY);

          case 5:
            reverseRegistryKey = _context11.sent;
            reverseTwitterRegistryStateBuff = borsh_1.serialize(ReverseTwitterRegistryState.schema, new ReverseTwitterRegistryState({
              twitterRegistryKey: twitterRegistryKey.toBytes(),
              twitterHandle: twitterHandle
            }));
            _context11.t0 = instructions_1;
            _context11.t1 = bindings_1.NAME_PROGRAM_ID;
            _context11.t2 = web3_js_1.SystemProgram.programId;
            _context11.t3 = reverseRegistryKey;
            _context11.t4 = verifiedPubkey;
            _context11.t5 = payerKey;
            _context11.t6 = hashedVerifiedPubkey;
            _context11.t7 = utils_1.Numberu64;
            _context11.next = 17;
            return connection.getMinimumBalanceForRentExemption(reverseTwitterRegistryStateBuff.length);

          case 17:
            _context11.t8 = _context11.sent;
            _context11.t9 = new _context11.t7(_context11.t8);
            _context11.t10 = new utils_1.Numberu32(reverseTwitterRegistryStateBuff.length);
            _context11.t11 = exports.TWITTER_VERIFICATION_AUTHORITY;
            _context11.t12 = // Twitter authority acts as class for all reverse-lookup registries
            exports.TWITTER_ROOT_PARENT_REGISTRY_KEY;
            _context11.t13 = // Reverse registries are also children of the root
            exports.TWITTER_VERIFICATION_AUTHORITY;
            _context11.t14 = _context11.t0.createInstruction.call(_context11.t0, _context11.t1, _context11.t2, _context11.t3, _context11.t4, _context11.t5, _context11.t6, _context11.t9, _context11.t10, _context11.t11, _context11.t12, _context11.t13);
            _context11.t15 = instructions_1.updateInstruction(bindings_1.NAME_PROGRAM_ID, reverseRegistryKey, new utils_1.Numberu32(0), Buffer.from(reverseTwitterRegistryStateBuff), exports.TWITTER_VERIFICATION_AUTHORITY);
            return _context11.abrupt("return", [_context11.t14, _context11.t15]);

          case 26:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _createReverseTwitterRegistry.apply(this, arguments);
}

exports.createReverseTwitterRegistry = createReverseTwitterRegistry;